export default __webpack_public_path__ + "static/media/pic101.d380a7cc.jpg";